import {
  DIALER_OPEN_KEY,
  getStorageJSON,
  N2P_STORAGE,
  setStorageJSON,
} from 'constants/LocalStorage'

/**
 * Use localStorage n2p key for realtime changes to shown state
 *
 * @param {boolean} isOpen
 */
export const setDialerIsOpen = (isOpen = false) => {
  const n2pStorage = getStorageJSON(N2P_STORAGE, {})
  n2pStorage[DIALER_OPEN_KEY] = isOpen
  setStorageJSON(N2P_STORAGE, n2pStorage)
}
